import React from "react";
import {FormattedMessage} from "react-intl";
import {LoadingSkeleton} from "@spg/component_library";

/**
 * A text block with key-value pairs.
 */
function TopicContentViewerInfoBlock(props: {
  title: string;
  keys: string[];
  values?: string[];
}) {
  return (
    <div className="topicContentViewerInfoBlock">
      {props.values ? (
        <>
          <h2 className="topicContentViewerInfoBlockTitle">
            <FormattedMessage
              id={"topicContentViewer.infoBlock.title." + props.title}
            />
          </h2>
          <div className="topicContentViewerInfoBlockAttributes">
            {props.keys.map((key, i) => (
              <div key={key}>
                <b>
                  <FormattedMessage
                    id={"topicContentViewer.infoBlock.key." + key}
                  />
                  {": "}
                </b>
                {props.values ? props.values[i] : "–"}
              </div>
            ))}
          </div>
        </>
      ) : (
        <LoadingSkeleton height="220px" />
      )}
    </div>
  );
}

export {TopicContentViewerInfoBlock};
